import { render, staticRenderFns } from "./simIndex.vue?vue&type=template&id=e52d8208"
import script from "./simIndex.vue?vue&type=script&lang=js"
export * from "./simIndex.vue?vue&type=script&lang=js"
import style0 from "./simIndex.vue?vue&type=style&index=0&id=e52d8208&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports